import React, { Component,Fragment } from 'react';
import banner_mengduo from './image/mengduo/question.svg';
import slogan from './image/mengduo/question_text.svg';
import './Question.css';

export default class componentName extends Component {
    constructor(props){
        super(props)
        this.state={
            question:[{
                    q:"如何插电源线？",
                    a:"基于电源接口在搬运过程中可能会损坏的原因，我们设计了在电源口外面加了一个小门，避免过度碰触。插电源线的时候用配置的钥匙打开小门即可插电源线"
                },{
                    q:"网络信号不好怎么办？",
                    a:"检查设备是否安装了信号天线，如果没有安装，安装上应该就可以加强网络信号了"
                },{
                    q:"设备上面的编号是什么意义？",
                    a:"为了方便设备追踪，我们设计了给每台机子分配一个编号，软件第一次打开的时候需要输入设备名称，这个名称就是设备上贴的编号。"
                },{
                    q:"如何连接wifi ?",
                    a:"智量一体机是基于安卓系统研发，在最顶部手指下拉，就会看到设置wifi的菜单。"
                },{
                    q:"打印机不工作如何处理？",
                    a:"打印机右上角有打开打印机换打印纸的按钮，往上掀开，检查是否缺少打印纸，如果缺少打印纸，请自行更换打印纸。"
                },{
                    q:"如何关机？",
                    a:"设备底座部分有一个开关，按一下即可关机。"
                },{
                    q:"如何保证量体准确？",
                    a:"详细请看教程部分：不要穿宽大外套，按照量体提示进行站立量体。"
                },{
                    q:"量体失败是怎么回事？",
                    a:"有可能是站姿不正确，在站姿正确的情况下，在测试一遍；检查设备是否连接网络。"
                },
                ],
                develop:["t"],
                open:Boolean
        }
    }


    develop=(index)=>{
        const array = this.state.develop;
        const num = array.indexOf(index)
        if(num>-1){
            array.splice(num,1);
            this.setState({
                open:true
            })
        }else{
            array.push(index);
            this.setState({
                open:false
            })
        }
        console.log(array);
        console.log(index);
        console.log(this.state.develop.indexOf(index)>-1);
        
    }

    render() {
        return (
            <Fragment>
                <div className={global.constants.channel==="mengduo"? "banner_mengduo":"banner"}>
                    <div className="banner--content">
                        <img src={slogan} alt="slogan" />
                        <img src={ banner_mengduo} alt="" />
                    </div>
                </div>
                <div style={{marginTop:80,marginBottom:80}}>
                    {this.state.question.map((item,index)=>{
                        return(
                            <div className="body" onClick={this.develop.bind(this,index)}>    
                                <div className={this.state.develop.indexOf(index)===-1 ? "content--select" : "content"}>
                                    <div className="question">
                                        <div className={this.state.develop.indexOf(index)===-1 ? "Q--select" : "Q"}>
                                            Q
                                        </div>
                                        <div className={this.state.develop.indexOf(index)===-1 ? "triangle_border_right--select" : "triangle_border_right"}/>
                                        <div className="question_text">
                                            {item.q}
                                        </div>
                                    </div>
                                    {this.state.develop.indexOf(index)>-1 &&
                                    <div className="develop">
                                    -
                                    </div>
                                    }
                                    {this.state.develop.indexOf(index)===-1 &&
                                    <div className="develop">
                                    +
                                    </div>
                                    }
                                </div>
                                {this.state.develop.indexOf(index)>-1 &&
                                <div className="answer">
                                    {item.a}
                                </div>}
                            </div>
                        );
                    })}
                </div>
            </Fragment>
        )
    }
};



// WEBPACK FOOTER //
// ./src/Question.js